// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { DisplayNamedFragmentDoc, NamedFragmentDoc } from '../../../../fragments/commonFragments.generated';
import { ReviewScopeChangesCard_IncomingUpdateFragmentDoc } from '../../components/ReviewScopeChangesCard.generated';
import { AddTradePartnerModal_BidPackageFragmentDoc } from '../../components/AddTradePartnerModal.generated';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type PlanBasedBidsTableV2_BidPlanChildGroupsQueryVariables = Types.Exact<{
  bidPackageId: Types.Scalars['ID']['input'];
  productOfferingId: Types.Scalars['ID']['input'];
  showScope: Types.Scalars['Boolean']['input'];
  showChangesOnly?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type PlanBasedBidsTableV2_BidPlanChildGroupsQuery = { __typename?: 'Query', bidPackage: { __typename?: 'BidPackage', id: string, bidPlanGroups: Array<{ __typename?: 'BidPlanGroup', id: string, order: number, displayName: string, globalOption?: { __typename?: 'GlobalOption', id: string, name: string } | null | undefined, dimensions: Array<{ __typename?: 'BidPlanGroupDimension', id: string, name: string, globalOptionType?: { __typename?: 'GlobalOptionType', id: string, order: number } | null | undefined, globalOptionGroup?: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, order: number } } | null | undefined, globalOptions: Array<{ __typename?: 'GlobalOption', id: string, name: string }> }>, childGroups: Array<{ __typename?: 'BidPlanChildGroup', id: string, displayName: string, lines: Array<{ __typename?: 'BidPlanChildGroupLine', id: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string, globalOption: { __typename?: 'GlobalOption', id: string, name: string, type: { __typename?: 'GlobalOptionType', id: string }, group: { __typename?: 'GlobalOptionGroup', id: string } } }>, planBasedBidContractLineItems: Array<{ __typename?: 'PlanBasedBidContractLineItem', id: string, totalCostInCents: number, costCode: { __typename?: 'CostCode', id: string }, revision: { __typename?: 'BidContractRevision', id: string } }> }> }> }>, scopedLineItems?: Array<{ __typename?: 'BidPlanChildGroupScopedLine', id: string, childGroup: { __typename?: 'BidPlanChildGroup', id: string, displayName: string, group: { __typename?: 'BidPlanGroup', id: string } }, groupLine?: { __typename?: 'BidPlanChildGroupLine', id: string, displayName: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string, globalOption: { __typename?: 'GlobalOption', id: string, name: string, type: { __typename?: 'GlobalOptionType', id: string }, group: { __typename?: 'GlobalOptionGroup', id: string } } }>, planBasedBidContractLineItems: Array<{ __typename?: 'PlanBasedBidContractLineItem', id: string, totalCostInCents: number, costCode: { __typename?: 'CostCode', id: string }, revision: { __typename?: 'BidContractRevision', id: string } }> } | null | undefined, scopeLines: Array<{ __typename?: 'BidPackageScopeLine', changeType?: string | null | undefined, takeoffLineItemVersion: { __typename?: 'TakeoffLineItemVersion', quantity?: number | null | undefined, id: string, name: string, costTypeDetail: { __typename?: 'CostTypeDetail', code: Types.CostType, name: string }, location: { __typename?: 'Location', id: string, displayLocationPath: string }, materialVariant?: { __typename?: 'MaterialVariant', id: string, code: string } | null | undefined, unitOfMeasure: { __typename?: 'UnitOfMeasure', id: string, abbreviation: string, useQuantity: boolean }, options: Array<{ __typename?: 'ReadyPlanOption', id: string, name: string, code: string, order: number }>, item: { __typename?: 'Item', id: string, fullCode: string, name: string, costCode: { __typename?: 'CostCode', id: string } }, readyPlan:
            | { __typename?: 'ReadyPlan', id: string, version: { __typename?: 'ReadyPlanAggregateVersion', id: string } }
            | { __typename?: 'PlanPackage', id: string, version: { __typename?: 'ReadyPlanAggregateVersion', id: string } }
            | { __typename?: 'DesignPackage', id: string, version: { __typename?: 'ReadyPlanAggregateVersion', id: string } }
            | { __typename?: 'ProductOffering', id: string, version: { __typename?: 'ReadyPlanAggregateVersion', id: string } }
           }, previous?: { __typename?: 'TakeoffLineItemVersion', id: string, quantity?: number | null | undefined, options: Array<{ __typename?: 'ReadyPlanOption', id: string }>, unitOfMeasure: { __typename?: 'UnitOfMeasure', id: string }, materialVariant?: { __typename?: 'MaterialVariant', id: string } | null | undefined, location: { __typename?: 'Location', id: string } } | null | undefined }> }> } };

export type PlanBasedBidsTableV2_BidPackageFragment = { __typename?: 'BidPackage', id: string, isPlanBasedV2: boolean, isUnitBased: boolean, status: { __typename?: 'BidPackageStatusDetail', code: Types.BidPackageStatus }, productOfferings: Array<{ __typename?: 'ProductOffering', displayName: string, id: string, name: string }>, availableUpdates: Array<{ __typename?: 'BidPackageIncomingUpdate', id: string, source: { __typename?: 'ReadyPlanAggregateVersion', id: string, version?: number | null | undefined, readyPlan:
        | { __typename?: 'ReadyPlan', id: string }
        | { __typename?: 'PlanPackage', id: string }
        | { __typename?: 'DesignPackage', id: string }
        | { __typename?: 'ProductOffering', id: string }
       } }>, costCodes: Array<{ __typename?: 'CostCode', id: string, name: string }>, activeBidders: Array<{ __typename?: 'BidPackageBidder', id: string, name: string, kind: Types.BidPackageBidderKind, bidContract?: { __typename?: 'BidContract', id: string, latestRevision: { __typename?: 'BidContractRevision', id: string, lineItems: Array<{ __typename?: 'BidContractLineItem', id: string }> }, internalEstimateType?: { __typename?: 'InternalEstimateTypeDetail', code: Types.InternalEstimateType } | null | undefined } | null | undefined, tradePartner?: { __typename?: 'TradePartner', id: string } | null | undefined, request?: { __typename?: 'BidPackageRequest', id: string } | null | undefined }>, latestVersion: { __typename?: 'BidPackageVersion', id: string, latestBidContractRevisions: Array<{ __typename?: 'BidContractRevision', id: string, bidContract: { __typename?: 'BidContract', id: string } }> }, bidPackageGroup?: { __typename?: 'BidPackageGroup', id: string } | null | undefined, projects: Array<
    | { __typename?: 'StandaloneProject', id: string }
    | { __typename?: 'Region', id: string }
    | { __typename?: 'Market', id: string }
    | { __typename?: 'Community', id: string }
    | { __typename?: 'Subdivision', id: string }
    | { __typename?: 'Lot', id: string }
    | { __typename?: 'Structure', id: string }
    | { __typename?: 'Unit', id: string }
  >, optionsMissingFromPackage: Array<{ __typename?: 'MissingBidPlanOption', globalOption: { __typename?: 'GlobalOption', id: string, name: string }, productOfferings: Array<{ __typename?: 'ProductOffering', id: string, displayName: string, aggregateActive?: { __typename?: 'ReadyPlanAggregateVersion', id: string, version?: number | null | undefined } | null | undefined }> }>, relevantMarket: { __typename?: 'Market', id: string }, requests: Array<{ __typename?: 'BidPackageRequest', id: string, tradePartner: { __typename?: 'TradePartner', id: string } }>, internalEstimateBidContract?: { __typename?: 'BidContract', id: string } | null | undefined };

export type PlanBasedBidsTableV2_MissingBidPlanOptionFragment = { __typename?: 'MissingBidPlanOption', globalOption: { __typename?: 'GlobalOption', id: string, name: string }, productOfferings: Array<{ __typename?: 'ProductOffering', id: string, displayName: string, aggregateActive?: { __typename?: 'ReadyPlanAggregateVersion', id: string, version?: number | null | undefined } | null | undefined }> };

export type PlanBasedBidsTableV2_BidPackageBidderFragment = { __typename?: 'BidPackageBidder', id: string, name: string, kind: Types.BidPackageBidderKind, bidContract?: { __typename?: 'BidContract', id: string, latestRevision: { __typename?: 'BidContractRevision', id: string, lineItems: Array<{ __typename?: 'BidContractLineItem', id: string }> }, internalEstimateType?: { __typename?: 'InternalEstimateTypeDetail', code: Types.InternalEstimateType } | null | undefined } | null | undefined, tradePartner?: { __typename?: 'TradePartner', id: string } | null | undefined, request?: { __typename?: 'BidPackageRequest', id: string } | null | undefined };

export type PlanBasedBidsTableV2_BidContractRevisionFragment = { __typename?: 'BidContractRevision', id: string, bidContract: { __typename?: 'BidContract', id: string } };

export type PlanBasedBidsTableV2_NarrowedBidContractRevisionFragment = { __typename?: 'BidContractRevision', id: string, planBasedLineItems: Array<{ __typename?: 'PlanBasedBidContractLineItem', id: string, groupLine: { __typename?: 'BidPlanChildGroupLine', id: string, group: { __typename?: 'BidPlanChildGroup', id: string }, options: Array<{ __typename?: 'ReadyPlanOption', id: string, globalOption: { __typename?: 'GlobalOption', id: string, name: string, type: { __typename?: 'GlobalOptionType', id: string }, group: { __typename?: 'GlobalOptionGroup', id: string } } }>, planBasedBidContractLineItems: Array<{ __typename?: 'PlanBasedBidContractLineItem', id: string, totalCostInCents: number, costCode: { __typename?: 'CostCode', id: string }, revision: { __typename?: 'BidContractRevision', id: string } }> } }>, bidContract: { __typename?: 'BidContract', id: string } };

export type PlanBasedBidsTableV2_BidPlanGroupFragment = { __typename?: 'BidPlanGroup', id: string, order: number, displayName: string, globalOption?: { __typename?: 'GlobalOption', id: string, name: string } | null | undefined, dimensions: Array<{ __typename?: 'BidPlanGroupDimension', id: string, name: string, globalOptionType?: { __typename?: 'GlobalOptionType', id: string, order: number } | null | undefined, globalOptionGroup?: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, order: number } } | null | undefined, globalOptions: Array<{ __typename?: 'GlobalOption', id: string, name: string }> }>, childGroups: Array<{ __typename?: 'BidPlanChildGroup', id: string, displayName: string, lines: Array<{ __typename?: 'BidPlanChildGroupLine', id: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string, globalOption: { __typename?: 'GlobalOption', id: string, name: string, type: { __typename?: 'GlobalOptionType', id: string }, group: { __typename?: 'GlobalOptionGroup', id: string } } }>, planBasedBidContractLineItems: Array<{ __typename?: 'PlanBasedBidContractLineItem', id: string, totalCostInCents: number, costCode: { __typename?: 'CostCode', id: string }, revision: { __typename?: 'BidContractRevision', id: string } }> }> }> };

export type PlanBasedBidsTableV2_BidPlanGroupDimensionFragment = { __typename?: 'BidPlanGroupDimension', id: string, name: string, globalOptionType?: { __typename?: 'GlobalOptionType', id: string, order: number } | null | undefined, globalOptionGroup?: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, order: number } } | null | undefined, globalOptions: Array<{ __typename?: 'GlobalOption', id: string, name: string }> };

export type PlanBasedBidsTableV2_BidPlanChildGroupLineFragment = { __typename?: 'BidPlanChildGroupLine', id: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string, globalOption: { __typename?: 'GlobalOption', id: string, name: string, type: { __typename?: 'GlobalOptionType', id: string }, group: { __typename?: 'GlobalOptionGroup', id: string } } }>, planBasedBidContractLineItems: Array<{ __typename?: 'PlanBasedBidContractLineItem', id: string, totalCostInCents: number, costCode: { __typename?: 'CostCode', id: string }, revision: { __typename?: 'BidContractRevision', id: string } }> };

export type PlanBasedBidsTableV2_BidPlanChildGroupFragment = { __typename?: 'BidPlanChildGroup', id: string, displayName: string, lines: Array<{ __typename?: 'BidPlanChildGroupLine', id: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string, globalOption: { __typename?: 'GlobalOption', id: string, name: string, type: { __typename?: 'GlobalOptionType', id: string }, group: { __typename?: 'GlobalOptionGroup', id: string } } }>, planBasedBidContractLineItems: Array<{ __typename?: 'PlanBasedBidContractLineItem', id: string, totalCostInCents: number, costCode: { __typename?: 'CostCode', id: string }, revision: { __typename?: 'BidContractRevision', id: string } }> }> };

export type PlanBasedBidsTableV2_BidPlanChildGroupScopedLineFragment = { __typename?: 'BidPlanChildGroupScopedLine', id: string, childGroup: { __typename?: 'BidPlanChildGroup', id: string, displayName: string, group: { __typename?: 'BidPlanGroup', id: string } }, groupLine?: { __typename?: 'BidPlanChildGroupLine', id: string, displayName: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string, globalOption: { __typename?: 'GlobalOption', id: string, name: string, type: { __typename?: 'GlobalOptionType', id: string }, group: { __typename?: 'GlobalOptionGroup', id: string } } }>, planBasedBidContractLineItems: Array<{ __typename?: 'PlanBasedBidContractLineItem', id: string, totalCostInCents: number, costCode: { __typename?: 'CostCode', id: string }, revision: { __typename?: 'BidContractRevision', id: string } }> } | null | undefined, scopeLines: Array<{ __typename?: 'BidPackageScopeLine', changeType?: string | null | undefined, takeoffLineItemVersion: { __typename?: 'TakeoffLineItemVersion', quantity?: number | null | undefined, id: string, name: string, costTypeDetail: { __typename?: 'CostTypeDetail', code: Types.CostType, name: string }, location: { __typename?: 'Location', id: string, displayLocationPath: string }, materialVariant?: { __typename?: 'MaterialVariant', id: string, code: string } | null | undefined, unitOfMeasure: { __typename?: 'UnitOfMeasure', id: string, abbreviation: string, useQuantity: boolean }, options: Array<{ __typename?: 'ReadyPlanOption', id: string, name: string, code: string, order: number }>, item: { __typename?: 'Item', id: string, fullCode: string, name: string, costCode: { __typename?: 'CostCode', id: string } }, readyPlan:
        | { __typename?: 'ReadyPlan', id: string, version: { __typename?: 'ReadyPlanAggregateVersion', id: string } }
        | { __typename?: 'PlanPackage', id: string, version: { __typename?: 'ReadyPlanAggregateVersion', id: string } }
        | { __typename?: 'DesignPackage', id: string, version: { __typename?: 'ReadyPlanAggregateVersion', id: string } }
        | { __typename?: 'ProductOffering', id: string, version: { __typename?: 'ReadyPlanAggregateVersion', id: string } }
       }, previous?: { __typename?: 'TakeoffLineItemVersion', id: string, quantity?: number | null | undefined, options: Array<{ __typename?: 'ReadyPlanOption', id: string }>, unitOfMeasure: { __typename?: 'UnitOfMeasure', id: string }, materialVariant?: { __typename?: 'MaterialVariant', id: string } | null | undefined, location: { __typename?: 'Location', id: string } } | null | undefined }> };

export type PlanBasedBidsTableV2_BidPackageScopeLineFragment = { __typename?: 'BidPackageScopeLine', changeType?: string | null | undefined, takeoffLineItemVersion: { __typename?: 'TakeoffLineItemVersion', quantity?: number | null | undefined, id: string, name: string, costTypeDetail: { __typename?: 'CostTypeDetail', code: Types.CostType, name: string }, location: { __typename?: 'Location', id: string, displayLocationPath: string }, materialVariant?: { __typename?: 'MaterialVariant', id: string, code: string } | null | undefined, unitOfMeasure: { __typename?: 'UnitOfMeasure', id: string, abbreviation: string, useQuantity: boolean }, options: Array<{ __typename?: 'ReadyPlanOption', id: string, name: string, code: string, order: number }>, item: { __typename?: 'Item', id: string, fullCode: string, name: string, costCode: { __typename?: 'CostCode', id: string } }, readyPlan:
      | { __typename?: 'ReadyPlan', id: string, version: { __typename?: 'ReadyPlanAggregateVersion', id: string } }
      | { __typename?: 'PlanPackage', id: string, version: { __typename?: 'ReadyPlanAggregateVersion', id: string } }
      | { __typename?: 'DesignPackage', id: string, version: { __typename?: 'ReadyPlanAggregateVersion', id: string } }
      | { __typename?: 'ProductOffering', id: string, version: { __typename?: 'ReadyPlanAggregateVersion', id: string } }
     }, previous?: { __typename?: 'TakeoffLineItemVersion', id: string, quantity?: number | null | undefined, options: Array<{ __typename?: 'ReadyPlanOption', id: string }>, unitOfMeasure: { __typename?: 'UnitOfMeasure', id: string }, materialVariant?: { __typename?: 'MaterialVariant', id: string } | null | undefined, location: { __typename?: 'Location', id: string } } | null | undefined };

export type PlanBasedBidsTableV2_TakeoffLineItemVersionFragment = { __typename?: 'TakeoffLineItemVersion', quantity?: number | null | undefined, id: string, name: string, costTypeDetail: { __typename?: 'CostTypeDetail', code: Types.CostType, name: string }, location: { __typename?: 'Location', id: string, displayLocationPath: string }, materialVariant?: { __typename?: 'MaterialVariant', id: string, code: string } | null | undefined, unitOfMeasure: { __typename?: 'UnitOfMeasure', id: string, abbreviation: string, useQuantity: boolean }, options: Array<{ __typename?: 'ReadyPlanOption', id: string, name: string, code: string, order: number }>, item: { __typename?: 'Item', id: string, fullCode: string, name: string, costCode: { __typename?: 'CostCode', id: string } }, readyPlan:
    | { __typename?: 'ReadyPlan', id: string, version: { __typename?: 'ReadyPlanAggregateVersion', id: string } }
    | { __typename?: 'PlanPackage', id: string, version: { __typename?: 'ReadyPlanAggregateVersion', id: string } }
    | { __typename?: 'DesignPackage', id: string, version: { __typename?: 'ReadyPlanAggregateVersion', id: string } }
    | { __typename?: 'ProductOffering', id: string, version: { __typename?: 'ReadyPlanAggregateVersion', id: string } }
   };

export type PlanBasedBidsTableV2_PreviousTakeoffLineItemVersionFragment = { __typename?: 'TakeoffLineItemVersion', id: string, quantity?: number | null | undefined, options: Array<{ __typename?: 'ReadyPlanOption', id: string }>, unitOfMeasure: { __typename?: 'UnitOfMeasure', id: string }, materialVariant?: { __typename?: 'MaterialVariant', id: string } | null | undefined, location: { __typename?: 'Location', id: string } };

export const PlanBasedBidsTableV2_BidPackageBidderFragmentDoc = gql`
    fragment PlanBasedBidsTableV2_BidPackageBidder on BidPackageBidder {
  id
  name
  kind
  bidContract {
    id
    latestRevision {
      id
      lineItems {
        id
      }
    }
    internalEstimateType {
      code
    }
  }
  tradePartner {
    id
  }
  request {
    id
  }
}
    `;
export const PlanBasedBidsTableV2_BidContractRevisionFragmentDoc = gql`
    fragment PlanBasedBidsTableV2_BidContractRevision on BidContractRevision {
  id
  bidContract {
    id
  }
}
    `;
export const PlanBasedBidsTableV2_MissingBidPlanOptionFragmentDoc = gql`
    fragment PlanBasedBidsTableV2_MissingBidPlanOption on MissingBidPlanOption {
  globalOption {
    ...Named
  }
  productOfferings {
    id
    displayName
    aggregateActive {
      id
      version
    }
  }
}
    ${NamedFragmentDoc}`;
export const PlanBasedBidsTableV2_BidPackageFragmentDoc = gql`
    fragment PlanBasedBidsTableV2_BidPackage on BidPackage {
  id
  status {
    code
  }
  productOfferings {
    ...Named
    displayName
  }
  availableUpdates {
    ...ReviewScopeChangesCard_IncomingUpdate
    source {
      id
      readyPlan {
        id
      }
    }
  }
  costCodes {
    ...Named
  }
  activeBidders {
    ...PlanBasedBidsTableV2_BidPackageBidder
  }
  latestVersion {
    id
    latestBidContractRevisions {
      ...PlanBasedBidsTableV2_BidContractRevision
    }
  }
  bidPackageGroup {
    id
  }
  projects {
    id
  }
  optionsMissingFromPackage {
    ...PlanBasedBidsTableV2_MissingBidPlanOption
  }
  ...AddTradePartnerModal_BidPackage
}
    ${NamedFragmentDoc}
${ReviewScopeChangesCard_IncomingUpdateFragmentDoc}
${PlanBasedBidsTableV2_BidPackageBidderFragmentDoc}
${PlanBasedBidsTableV2_BidContractRevisionFragmentDoc}
${PlanBasedBidsTableV2_MissingBidPlanOptionFragmentDoc}
${AddTradePartnerModal_BidPackageFragmentDoc}`;
export const PlanBasedBidsTableV2_BidPlanChildGroupLineFragmentDoc = gql`
    fragment PlanBasedBidsTableV2_BidPlanChildGroupLine on BidPlanChildGroupLine {
  id
  options {
    id
    globalOption {
      ...Named
      type {
        id
      }
      group {
        id
      }
    }
  }
  planBasedBidContractLineItems {
    id
    totalCostInCents
    costCode {
      id
    }
    revision {
      id
    }
  }
}
    ${NamedFragmentDoc}`;
export const PlanBasedBidsTableV2_NarrowedBidContractRevisionFragmentDoc = gql`
    fragment PlanBasedBidsTableV2_NarrowedBidContractRevision on BidContractRevision {
  ...PlanBasedBidsTableV2_BidContractRevision
  planBasedLineItems {
    id
    groupLine {
      group {
        id
      }
      ...PlanBasedBidsTableV2_BidPlanChildGroupLine
    }
  }
}
    ${PlanBasedBidsTableV2_BidContractRevisionFragmentDoc}
${PlanBasedBidsTableV2_BidPlanChildGroupLineFragmentDoc}`;
export const PlanBasedBidsTableV2_BidPlanGroupDimensionFragmentDoc = gql`
    fragment PlanBasedBidsTableV2_BidPlanGroupDimension on BidPlanGroupDimension {
  id
  name
  globalOptionType {
    id
    order
  }
  globalOptionGroup {
    id
    type {
      id
      order
    }
  }
  globalOptions {
    ...Named
  }
}
    ${NamedFragmentDoc}`;
export const PlanBasedBidsTableV2_BidPlanChildGroupFragmentDoc = gql`
    fragment PlanBasedBidsTableV2_BidPlanChildGroup on BidPlanChildGroup {
  id
  displayName
  lines {
    ...PlanBasedBidsTableV2_BidPlanChildGroupLine
  }
}
    ${PlanBasedBidsTableV2_BidPlanChildGroupLineFragmentDoc}`;
export const PlanBasedBidsTableV2_BidPlanGroupFragmentDoc = gql`
    fragment PlanBasedBidsTableV2_BidPlanGroup on BidPlanGroup {
  id
  order
  displayName
  globalOption {
    ...Named
  }
  dimensions {
    ...PlanBasedBidsTableV2_BidPlanGroupDimension
  }
  childGroups(productOfferingId: $productOfferingId) {
    ...PlanBasedBidsTableV2_BidPlanChildGroup
  }
}
    ${NamedFragmentDoc}
${PlanBasedBidsTableV2_BidPlanGroupDimensionFragmentDoc}
${PlanBasedBidsTableV2_BidPlanChildGroupFragmentDoc}`;
export const PlanBasedBidsTableV2_TakeoffLineItemVersionFragmentDoc = gql`
    fragment PlanBasedBidsTableV2_TakeoffLineItemVersion on TakeoffLineItemVersion {
  ...Named
  quantity
  costTypeDetail {
    code
    name
  }
  location {
    id
    displayLocationPath
  }
  materialVariant {
    id
    code
  }
  unitOfMeasure {
    id
    abbreviation
    useQuantity
  }
  options {
    id
    name
    code
    order
  }
  item {
    id
    fullCode
    name
    costCode {
      id
    }
  }
  materialVariant {
    id
    code
  }
  readyPlan {
    id
    version {
      id
    }
  }
}
    ${NamedFragmentDoc}`;
export const PlanBasedBidsTableV2_PreviousTakeoffLineItemVersionFragmentDoc = gql`
    fragment PlanBasedBidsTableV2_PreviousTakeoffLineItemVersion on TakeoffLineItemVersion {
  id
  quantity
  options {
    id
  }
  unitOfMeasure {
    id
  }
  materialVariant {
    id
  }
  location {
    id
  }
}
    `;
export const PlanBasedBidsTableV2_BidPackageScopeLineFragmentDoc = gql`
    fragment PlanBasedBidsTableV2_BidPackageScopeLine on BidPackageScopeLine {
  takeoffLineItemVersion {
    ...PlanBasedBidsTableV2_TakeoffLineItemVersion
  }
  changeType
  previous {
    ...PlanBasedBidsTableV2_PreviousTakeoffLineItemVersion
  }
}
    ${PlanBasedBidsTableV2_TakeoffLineItemVersionFragmentDoc}
${PlanBasedBidsTableV2_PreviousTakeoffLineItemVersionFragmentDoc}`;
export const PlanBasedBidsTableV2_BidPlanChildGroupScopedLineFragmentDoc = gql`
    fragment PlanBasedBidsTableV2_BidPlanChildGroupScopedLine on BidPlanChildGroupScopedLine {
  id
  childGroup {
    id
    displayName
    group {
      id
    }
  }
  groupLine {
    ...DisplayNamed
    ...PlanBasedBidsTableV2_BidPlanChildGroupLine
  }
  scopeLines {
    ...PlanBasedBidsTableV2_BidPackageScopeLine
  }
}
    ${DisplayNamedFragmentDoc}
${PlanBasedBidsTableV2_BidPlanChildGroupLineFragmentDoc}
${PlanBasedBidsTableV2_BidPackageScopeLineFragmentDoc}`;
export const PlanBasedBidsTableV2_BidPlanChildGroupsDocument = gql`
    query PlanBasedBidsTableV2_BidPlanChildGroups($bidPackageId: ID!, $productOfferingId: ID!, $showScope: Boolean!, $showChangesOnly: Boolean) {
  bidPackage(id: $bidPackageId) {
    id
    bidPlanGroups {
      ...PlanBasedBidsTableV2_BidPlanGroup
    }
    scopedLineItems(
      productOfferingId: $productOfferingId
      showChangesOnly: $showChangesOnly
    ) @include(if: $showScope) {
      ...PlanBasedBidsTableV2_BidPlanChildGroupScopedLine
    }
  }
}
    ${PlanBasedBidsTableV2_BidPlanGroupFragmentDoc}
${PlanBasedBidsTableV2_BidPlanChildGroupScopedLineFragmentDoc}`;

/**
 * __usePlanBasedBidsTableV2_BidPlanChildGroupsQuery__
 *
 * To run a query within a React component, call `usePlanBasedBidsTableV2_BidPlanChildGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlanBasedBidsTableV2_BidPlanChildGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlanBasedBidsTableV2_BidPlanChildGroupsQuery({
 *   variables: {
 *      bidPackageId: // value for 'bidPackageId'
 *      productOfferingId: // value for 'productOfferingId'
 *      showScope: // value for 'showScope'
 *      showChangesOnly: // value for 'showChangesOnly'
 *   },
 * });
 */
export function usePlanBasedBidsTableV2_BidPlanChildGroupsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PlanBasedBidsTableV2_BidPlanChildGroupsQuery, PlanBasedBidsTableV2_BidPlanChildGroupsQueryVariables> & ({ variables: PlanBasedBidsTableV2_BidPlanChildGroupsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PlanBasedBidsTableV2_BidPlanChildGroupsQuery, PlanBasedBidsTableV2_BidPlanChildGroupsQueryVariables>(PlanBasedBidsTableV2_BidPlanChildGroupsDocument, options);
      }
export function usePlanBasedBidsTableV2_BidPlanChildGroupsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PlanBasedBidsTableV2_BidPlanChildGroupsQuery, PlanBasedBidsTableV2_BidPlanChildGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PlanBasedBidsTableV2_BidPlanChildGroupsQuery, PlanBasedBidsTableV2_BidPlanChildGroupsQueryVariables>(PlanBasedBidsTableV2_BidPlanChildGroupsDocument, options);
        }
// @ts-ignore
export function usePlanBasedBidsTableV2_BidPlanChildGroupsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<PlanBasedBidsTableV2_BidPlanChildGroupsQuery, PlanBasedBidsTableV2_BidPlanChildGroupsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PlanBasedBidsTableV2_BidPlanChildGroupsQuery, PlanBasedBidsTableV2_BidPlanChildGroupsQueryVariables>;
export function usePlanBasedBidsTableV2_BidPlanChildGroupsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PlanBasedBidsTableV2_BidPlanChildGroupsQuery, PlanBasedBidsTableV2_BidPlanChildGroupsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PlanBasedBidsTableV2_BidPlanChildGroupsQuery | undefined, PlanBasedBidsTableV2_BidPlanChildGroupsQueryVariables>;
export function usePlanBasedBidsTableV2_BidPlanChildGroupsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PlanBasedBidsTableV2_BidPlanChildGroupsQuery, PlanBasedBidsTableV2_BidPlanChildGroupsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PlanBasedBidsTableV2_BidPlanChildGroupsQuery, PlanBasedBidsTableV2_BidPlanChildGroupsQueryVariables>(PlanBasedBidsTableV2_BidPlanChildGroupsDocument, options);
        }
export type PlanBasedBidsTableV2_BidPlanChildGroupsQueryHookResult = ReturnType<typeof usePlanBasedBidsTableV2_BidPlanChildGroupsQuery>;
export type PlanBasedBidsTableV2_BidPlanChildGroupsLazyQueryHookResult = ReturnType<typeof usePlanBasedBidsTableV2_BidPlanChildGroupsLazyQuery>;
export type PlanBasedBidsTableV2_BidPlanChildGroupsSuspenseQueryHookResult = ReturnType<typeof usePlanBasedBidsTableV2_BidPlanChildGroupsSuspenseQuery>;
export type PlanBasedBidsTableV2_BidPlanChildGroupsQueryResult = ApolloReactCommon.QueryResult<PlanBasedBidsTableV2_BidPlanChildGroupsQuery, PlanBasedBidsTableV2_BidPlanChildGroupsQueryVariables>;